<div class="sidebar included">
	<app-sidebar-header [title]="'What\'s included'">
		<div custom-label>
			<app-svg *ngIf="brand !== null" class="logo_brand" [ngClass]="['brand--'+brand.id]"
				[alt]="brand.label + ' logo'" svg="sprite.svg#brand--{{brand.id}}" aria-hidden="true">
			</app-svg>
		</div>
	</app-sidebar-header>

	<div class="sidebar__body sl--scrollable" #sidebar__body>
		<div class="sidebar-flight" *ngIf="brand !== null">
			<div class="sidebar-flight-extras">
				<ul class="body">
					<li *ngFor="let feature of brandFeatures; let i = index" class="extras-feature">
						<app-svg [ngClass]="['extras-feature__icon']"
							svg="icons.svg#{{feature.icon || 'general--plus'}}" [alt]="feature.label + ' icon'">
						</app-svg>
						<div class="extras-feature__label">
							<span>{{feature.label}}</span>
							<span class="muted-light">{{feature.description}}</span>
						</div>
					</li>
				</ul>
			</div>
		</div>
		<div class="sidebar-flight-text">
			<p><a class="link extras-feature__link" aria-label="Close dialog" (click)="TAP_handleClose()"
					href="javascript:;" role="button">Close this
					window</a></p>
		</div>
	</div>
</div>